/**
 * Data
 *
 * Module that handles the getting and setting of data in the Search application
 *
 * @return {type}
 */

OT.createNS('OT.Search.Data');

OT.Search.Data = (function() {
    'use strict';

    var searchData = window.OTSearchData || {};

    var get = function() {
        return searchData;
    };

    var set = function(data) {
        _.extend(searchData, data);
    };

    var clear = function() {
        searchData = {};
    };

    return {
        get: get,
        set: set,
        clear: clear
    };

})();